import * as React from 'react';
import { Anchor } from '@radix-ui/react-popover';
import type { PopoverAnchorProps } from '@radix-ui/react-popover';
import { cn } from '@mentimeter/ragnar-tailwind-config';

export const PopoverAnchor = (props: PopoverAnchorProps) => {
  const { className, ...rest } = props;
  return <Anchor asChild className={cn(className)} {...rest} />;
};
